'use client';
import React from 'react';
import {Card, FileUploader, Heading} from '@ui';
import { withOptionalId } from '@lib/withOptionalId';
import { Section, Container } from '@layout';
import MarkupSnippet, { markupCopyLabels } from '../markup-snippet/MarkupSnippet';

interface FileUploaderDemoProps {
  sectionID?: string;
  classes?: string;
  containerId?: string;
  containerClasses?: string;
  isSpanish?: boolean;
}

const FileUploaderDemo: React.FC<FileUploaderDemoProps> = ({
  isSpanish = false,
  sectionID = '',
  classes = '',
  containerId,
  containerClasses,
}) => {
  const t = (en: string, es: string) => (isSpanish ? es : en);

  return (
    <Section {...withOptionalId(sectionID)} className={classes}>
      <Container containerId={containerId} containerClasses={containerClasses}>
        <Heading as="h3">{t('File Uploader', 'Subidor de archivos')}</Heading>
        <p className='sub full'>
          {t(
            'Drag files here or browse. Shows basic validation and mock progress.',
            'Arrastra archivos aquí o busca. Muestra validacion basica y progreso simulado.'
          )}
        </p>
        <Card>
          <FileUploader />
        </Card>
      <MarkupSnippet
          {...markupCopyLabels(isSpanish)}
          code={`<div class="uploader">
  <input class="uploader-input" type="file" />
  <div class="card dropzone">
    <div class="dropzone-inner">Drop files here</div>
  </div>
</div>`}
        />
      </Container>
    </Section>
  );
};

export default FileUploaderDemo;
